import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { LoadingIndicatorProps } from '../models';

@Injectable({
	providedIn: 'root'
})
export class LoadingIndicatorState {
	public isLoading$: Observable<LoadingIndicatorProps>;
	private isLoading: BehaviorSubject<LoadingIndicatorProps>;

	public constructor() {
		this.isLoading = new BehaviorSubject({ isLoading: false, message: '' });
		this.isLoading$ = this.isLoading.asObservable().pipe(distinctUntilChanged());
	}

	public setIsLoading(isLoading: boolean, message?: string) {
		this.isLoading.next({ isLoading, message });
	}
}
